const InvestmentCard = ({ 
  company, 
  logoSrc, 
  hoverLogoSrc, 
  stage, 
  description, 
  coInvestors,
  expanded,
  onToggle
}) => {
  const toggleExpand = () => {
    onToggle(expanded ? null : company);
  };
  
  return (
    <>
      {!expanded ? (
        <div 
          className="investment-card bg-white dark:bg-gray-800 p-3 rounded-lg border border-gray-200 dark:border-gray-700 hover:shadow-md transition-all flex flex-col items-center cursor-pointer group relative"
          onClick={toggleExpand}
        >
          <div className="absolute top-2 right-2">
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              stage === 'Seed' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' :
              stage === 'Series A' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' :
              stage === 'Series B' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200' :
              stage === 'Series C' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
              'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200'
            }`}>
              {stage}
            </span>
          </div>
          
          <div className="w-12 h-12 mb-2 rounded-lg flex items-center justify-center overflow-hidden">
            {hoverLogoSrc ? (
              <>
                <img 
                  src={logoSrc} 
                  alt={`${company} logo`} 
                  className="w-full h-full object-contain group-hover:hidden"
                  loading="lazy"
                  width="48"
                  height="48"
                />
                <img 
                  src={hoverLogoSrc} 
                  alt={`${company} alternate logo`} 
                  className="w-full h-full object-contain hidden group-hover:block"
                  loading="lazy"
                  width="48"
                  height="48"
                />
              </>
            ) : (
              <img 
                src={logoSrc} 
                alt={`${company} logo`} 
                className="w-full h-full object-contain"
                loading="lazy"
                width="48"
                height="48"
              />
            )}
          </div>
          
          <h4 className={`text-sm font-medium ${hoverLogoSrc ? 'group-hover:text-pink-600' : ''}`}>
            {company}
          </h4>
        </div>
      ) : (
        <div 
          className="col-span-full bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-md transition-all"
        >
          <div className="flex items-start">
            <div className="w-14 h-14 rounded-lg flex-shrink-0 overflow-hidden mr-4">
              <img 
                src={logoSrc} 
                alt={`${company} logo`} 
                className="w-full h-full object-contain"
                loading="lazy"
                width="56"
                height="56"
              />
            </div>
            
            <div className="flex-1">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-base font-bold">{company}</h3>
                  <span className={`text-xs px-2 py-0.5 rounded-full inline-block mt-1 ${
                    stage === 'Seed' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' :
                    stage === 'Series A' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' :
                    stage === 'Series B' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200' :
                    stage === 'Series C' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
                    'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200'
                  }`}>
                    {stage}
                  </span>
                </div>
                
                <button 
                  onClick={toggleExpand}
                  className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <p className="text-sm text-gray-600 dark:text-gray-300 mt-2">
                {description}
              </p>
              
              <div className="mt-3">
                <h4 className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Co-Investors:</h4>
                <div className="flex flex-wrap gap-1">
                  {coInvestors.map((investor, index) => (
                    <span 
                      key={index}
                      className="text-xs px-2 py-0.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-full"
                    >
                      {investor}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InvestmentCard;